import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from '@/App.vue'
import router from '@/router'
import { useAuthStore } from '@/stores/auth'
import '@/style.css'

/**
 * Стор авторизации инстанцируется ЯВНО между пинией и роутером.
 *
 * Он поднялся бы и лениво — на первом `useAuthStore()` внутри гварда, — но
 * тогда момент сборки моста с транспортом (`setAuthLostHandler` и соседи)
 * зависел бы от того, какой гвард сработал первым. Здесь порядок виден
 * глазами: пиния есть, роутер ещё не начал первую навигацию.
 */
function bootstrap(): void {
  const app = createApp(App)

  app.use(createPinia())
  useAuthStore()
  app.use(router)

  app.mount('#app')
}

bootstrap()
